<template>
  <b-col :xl="size">
    <b-card no-body>
      <b-row align-v="center" slot="header">
        <b-col>
          <h6 class="text-uppercase ls-1 mb-1">Active Pipeline Ratings</h6>
          <h5 class="h3 mb-0">{{ title }}</h5>
        </b-col>
        <b-col class="text-right">
          <b-button-group size="sm">
            <b-button @click="chartType = 'chart'" :variant="chartType == 'chart' ? 'primary' : 'outline-primary'">Chart</b-button>
            <b-button @click="chartType = 'data'" :variant="chartType == 'data' ? 'primary' : 'outline-primary'">Data</b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <div class="chart-area pt-2 pb-3" v-if="chartData">
        <div class="px-4">
          <div class="py-2 d-flex justify-content-between align-items-center">
            <small><strong>Total Volume:</strong></small>
            <b-badge variant="primary" pill>{{ totalVolume | currency }}</b-badge>
          </div>
          <b-form-group
            label-for="rating">
            <b-form-select size="sm" v-model="rating" @change="getItems">
              <b-form-select-option :value="''">All Ratings</b-form-select-option>
              <b-form-select-option :value="rating" v-for="(rating, key) in ratings" :key="key">{{ rating }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="chart" v-if="chartType == 'chart'">
          <pie-chart
            id="pie-chart"
            :height="350"
            :chart-data="pieChart.chartData"
            :extra-options="pieChart.extraOptions"
          >
          </pie-chart>
        </div>
        <div v-else>
          <b-list-group flush size="sm">
            <b-list-group-item v-for="(label, key) in chartData.labels" :key="key" class="py-2 d-flex justify-content-between align-items-center"><small>{{ label }}</small> 
              <b-badge variant="primary" pill>{{ chartData.datasets[0].data[key] | currency }}</b-badge>
            </b-list-group-item>
            <b-list-group-item class="py-2 d-flex justify-content-between align-items-center"><small><strong>Total Volume</strong></small>
              <b-badge variant="primary" pill>{{ totalVolume | currency }}</b-badge>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
    </b-card>
  </b-col>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import PieChart from '@/components/Charts/PieChart';
import * as chartConfigs from '@/components/Charts/config';
import { Charts } from '@/components/Charts/config';
import {Select, Option} from 'element-ui';

export default {
  mixins: [errorsMixin],
  components: {
    PieChart,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    title: null,
    subTitle: null,
    userRoute: null,
    type: null,
    size: null
  },
  data() {
    return {
      chartType: 'chart',
      ratings: [10, 9, 8, 7, 6, 5],
      rating: '',
      chartData: null,
      pieChart: {
        chartData: {
          labels: [],
          datasets: [{
            data: [],
            backgroundColor: [],
            label: ''
          }],
        },
        extraOptions: {
          responsive: true,
          legend: {
            visible: true,
            position: 'top',
          },
          animation: {
            animateScale: true,
            animateRotate: true
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                var dataLabel = data.labels[tooltipItem.index];
                var value = ': $' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString();

                if (Chart.helpers.isArray(dataLabel)) {
                  dataLabel = dataLabel.slice();
                  dataLabel[0] += value;
                } else {
                  dataLabel += value;
                }

                return dataLabel;
              }
            }
          },
        }
      },
    }
  },
  computed: {
    totalVolume() {
      return this.chartData.datasets[0].data.reduce((total, a) => total + a, 0);
    }
  },
  methods: {
    async getItems() {
       await axios.get(this.userRoute + "/reports/pipelines/" + this.type + "?rating=" + this.rating)
      .then(response => {
        this.chartData = response.data;
        this.pieChart.chartData = this.chartData;
      })
      .catch(error => {
        this.error(error);
      });
    }
  },
  created() {
    this.getItems();
  }
};
</script>